
<template>
	<div class="position-relative">
		<compFormEdit
			ref="baseform"
			class="margin-layout"
			:formdata="getTempCode"
			v-model="formData"
			col="1"
		></compFormEdit>
		<vButtonGroup class="text-right">
			<vButton theme="primary" class="margin-right-10" @click="submit">确认</vButton>
			<vButton @click="close">返回</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer fixed :loading="loading"></vLoading>
	</div>
</template>
<script>
import { HttpSaveTempalteStorageOne, HttpTempalteStorage } from '@/service/billing';
export default {
	props: ['activeids', 'operatype'],
	components: {
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
			loading: false,
			formData: {
				unit: 'BILL_UNIT_CUBIC_FOOT',
				currency: 'USD',
				billingTemplateId: this.$route.query.id,
			},
		}
	},
	created() {
		if (this.operatype == 'edit') this.getDetail()
	},
	computed: {
		getTempCode() {
			return [
				// {
				// 	label: '计费单位',
				// 	// tag: 'vSelect',
				// 	key: 'unit',
				// 	options: [
				// 		{ value: 'BILL_UNIT_CUBIC_FOOT', label: '立方英尺' },
				// 	],
				// 	query: true
				// },
				{
					label: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
					tag: 'vSelect',
					key: 'inventoryType',
					options: [
						{ value: 'CAN_SALE', label: this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' }) },
						{ value: 'NO_SALE', label: this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' }) },
					],
				},
				{
					label: this.$t('fbb.accountmanage.save_day_start', { defaultValue: '存储天数(起)' }),
					tag: 'vInputNumber',
					key: 'storageStart',
					props:{
						min:1
					}
				},
				{
					label: this.$t('fbb.accountmanage.save_day_end', { defaultValue: '存储天数(止)' }),
					tag: 'vInputNumber',
					key: 'storageEnd',
					props:{
						min:1
					}
				},
				{
					label: this.$t('fbb.accountmanage.feilv', { defaultValue: '费率' }),
					tag: 'vInputNumber',
					key: 'rate',
					props:{
						min:0
					}
				},
				{
					label: this.$t('global.common.currency', { defaultValue: '币种' }),
					// tag: 'vInput',
					key: 'currency',
					query: true
				},
			]
		}
	},
	methods: {
		getDetail() {
			this.loading = true;
			HttpTempalteStorage({
				id: this.activeids,
			}).then(res => {
				this.loading = false;
				this.formData = res.data
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		async submit() {
			const valid = await this.$refs['baseform'].validate();
			if (!valid) return;
			if(this.formData.storageEnd<this.formData.storageStart){
				this.$VMessage.error(this.$t('fbb.accountmanage.error_tip_1', { defaultValue: '存储天数(止)不能小于存储天数(起)' }));
				return
			}
			this.loading = true;
			HttpSaveTempalteStorageOne(this.formData).then(res => {
				this.loading = false;
				this.close();
				this.$emit('on-update');
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
			// sessionStorage.setItem('billcode', JSON.stringify(this.formData))
		},
		close() {
			this.$emit('on-close');
		}
	}
}
</script>
